/** Angular Imports */
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

/** rxjs Imports */
import { Observable } from 'rxjs';

/** Custom Services */
import { VaultTransactionsService } from 'app/vault-transactions/vault-transactions.service';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';

/**
 * Vault transaction data resolver.
 */
@Injectable()
export class VaultTransactionsTemplateResolver implements Resolve<Object> {
    selectedTeller: any;

  /**
   * @param {OrganizationService} organizationService Organization service.
   */
  constructor(private vaultTransactionsService: VaultTransactionsService,
    private tellerGlobalService: TellerGlobalServiceService) {
    this.tellerGlobalService.getSelectedTeller$().subscribe(
        data => this.selectedTeller = data)
  }

  /**
   * Returns the cashier transaction data.
   * @returns {Observable<any>}
   */
  resolve(route: ActivatedRouteSnapshot): Observable<any> {            
    return this.vaultTransactionsService.getCashierTransactionTemplate(this.selectedTeller['id']);
  }

}
